import { pushHistory, removeHistoryEntry, resetHistory } from '@/utils/History'
import { CALENDAR_HISTORY, captureCalendarDays, diffCalendarDays, restoreCalendarDays } from '@/utils/CalendarHistory'

export default {
    beforeDestroy() {
        resetHistory(CALENDAR_HISTORY)
    },
    methods: {
        calendarHistoryScope() {
            const vm = this
            if (vm.currentGroupBy === 'students') {
                return { collection: 'assignedRoutines', studentId: vm.currentStudent?.objectID || null }
            }
            const group = vm.currentGroupBy === 'groups' ? vm.currentGroup : vm.currentTeamGroup
            if (!group) return null
            return {
                collection: 'groupAssignedRoutines',
                groupId: group.id,
                teamId: vm.currentGroupBy === 'teams' ? (vm.currentTeam?.id || null) : null,
                students: group.students || [],
            }
        },
        async captureCalendarSafe(scope, dates) {
            try {
                return await captureCalendarDays(scope, dates)
            } catch (error) {
                console.error('[calendar history] capture', error)
                return null
            }
        },
        pushCalendarChanges(label, before, afterPromise, key = null) {
            const vm = this
            if (!before) return
            const changesPromise = Promise.resolve(afterPromise).then(after => after ? diffCalendarDays(before, after) : [])
            vm._pendingAfter = changesPromise
            const apply = side => async () => {
                const changes = await changesPromise
                if (!changes.length) return
                await restoreCalendarDays(changes, side)
                await vm.refreshCalendarEvents()
            }
            const redo = apply('after')
            const entry = pushHistory(CALENDAR_HISTORY, { label, key, undo: apply('before'), redo })
            changesPromise.then(changes => {
                if (!changes.length && entry && entry.redo === redo) removeHistoryEntry(CALENDAR_HISTORY, entry)
            })
        },
        async trackCalendar(label, dates, fn, key = null) {
            const vm = this
            const scope = vm.calendarHistoryScope()
            await vm._pendingAfter
            const before = scope ? await vm.captureCalendarSafe(scope, dates) : null
            const result = await fn()
            if (before) vm.pushCalendarChanges(label, before, vm.captureCalendarSafe(scope, dates), key)
            return result
        },
        beginCalendarTrack(source, label, dates) {
            const vm = this
            const scope = vm.calendarHistoryScope()
            if (!scope) return vm._calendarTrack = null
            const before = Promise.resolve(vm._pendingAfter).then(() => vm.captureCalendarSafe(scope, dates))
            vm._calendarTrack = { source, label, dates, scope, before }
            return vm._calendarTrack.before
        },
        async endCalendarTrack(source, label = null) {
            const vm = this
            const track = vm._calendarTrack
            if (!track || track.source !== source) return
            vm._calendarTrack = null
            const before = await track.before
            if (!before) return
            vm.pushCalendarChanges(label || track.label, before, vm.captureCalendarSafe(track.scope, track.dates))
        },
        resetCalendarHistory() {
            this._calendarTrack = null
            resetHistory(CALENDAR_HISTORY)
        },
    },
}
